import { useForgotPasswordMutation } from 'api/auth'
import Background from 'components/Auth/Background'
import Content from 'components/Auth/Content'
import Footer from 'components/Auth/Footer'
import ForgotPasswordForm from 'components/Auth/ForgotPasswordForm'
import { FormProps } from 'components/Auth/ForgotPasswordForm/validator'
import Layout from 'components/Auth/Layout'
import { GetStaticProps, NextPage } from 'next'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { showSuccessToast } from 'utils/toast'

const ForgotPassword: NextPage = () => {
  const { t } = useTranslation('forgot-password')
  const router = useRouter()

  const [forgotPassword, { isLoading }] = useForgotPasswordMutation()

  const submit = async (data: FormProps) => {
    await forgotPassword(data).unwrap()
    showSuccessToast([t('submit-success-message')])
    router.back()
  }

  return (
    <Layout title={t('title')}>
      <Background>
        <Content title={t('reset-password')}>
          <ForgotPasswordForm
            onSubmit={submit}
            onGoBack={router.back}
            isLoading={isLoading}
          />
        </Content>
        <Footer />
      </Background>
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale || 'en', [
      'forgot-password',
      'validation',
      'auth',
    ])),
  },
})

export default ForgotPassword
